import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import axios from 'axios';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

axios.defaults.baseURL = 'http://valuacion.gtsf.com.mx:9548';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
